import { styled } from "@mui/system";

import { BreakPointTheme, theme } from "theme";

export const Image = styled("div")<{
  photoURL: string;
  maxContent: boolean;
  isSelectMode: boolean;
  isSelected: boolean;
  isDrug: boolean;
}>(({ photoURL, maxContent, isDrug }) => ({
  position: "relative",
  background: `url(${photoURL}) center/cover no-repeat`,
  width: "100%",

  ...(isDrug
    ? {
        cursor: "grab",
      }
    : {
        cursor: "pointer",
      }),

  ...(maxContent
    ? {
        height: "165px",

        [BreakPointTheme.breakpoints.down(1440)]: {
          height: "120px",
        },

        [BreakPointTheme.breakpoints.down("lg")]: {
          height: "200px",
        },
      }
    : {
        height: "270px",

        [BreakPointTheme.breakpoints.down(1600)]: {
          height: "230px",
        },

        [BreakPointTheme.breakpoints.down(1440)]: {
          height: "190px",
        },

        [BreakPointTheme.breakpoints.down(1200)]: {
          height: "165px",
        },

        [BreakPointTheme.breakpoints.down("lg")]: {
          height: "200px",
        },
      }),
}));

export const FavoriteButton = styled("button")({
  position: "absolute",
  top: "10px",
  left: "10px",
  padding: "0",
  border: "none",
  cursor: "pointer",
  background: "transparent",

  [BreakPointTheme.breakpoints.down("lg")]: {
    top: "0px",
    left: "0px",
    padding: "10px",
  },
});

export const RatingStarWrapper = styled("div")<{ isFavorite?: boolean }>(
  ({ isFavorite }) => ({
    borderRadius: "50%",
    background: isFavorite ? theme.color.primary[800] : theme.color.grey[400],
    cursor: "pointer",
    width: "28px",
    height: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    [BreakPointTheme.breakpoints.down("lg")]: {
      width: "28px",
      height: "28px",

      svg: {
        width: "20px",
        height: "20px",
      },
    },
  }),
);

export const SelectIconContainer = styled("div")({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translateX(-50%) translateY(-50%)",

  svg: {
    width: "60px",
    height: "60px",

    "@media (max-width: 1024px)": {
      width: "30px",
      height: "30px",
    },
  },
});

export const BackGround = styled("div")({
  position: "absolute",
  top: "0",
  right: "0",
  bottom: "0",
  left: "0",
  background: theme.color.black,
  opacity: "0.5",
});
